module.exports = __webpack_public_path__ + "img/exit_fullscreen.5e6f6874.svg";